const EMPTY_REASON_TITLE = 'Запланировано';

export const EMPTY_PLAN_REASON = {
  id: null,
  title: EMPTY_REASON_TITLE,
  isActive: true,
};
